import { createAction } from '@reduxjs/toolkit';

import { mbcSearchModule } from './constants';

const routeMBCSearch = createAction(`${mbcSearchModule}/ROUTE_MBC_SEARCH`);
export const ROUTE_MBC_SEARCH = routeMBCSearch.type;
